/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import * as React from 'react';

import type { StepStatus } from '../../types';

// Hexagon paths match src/assets/images/step-*.svg geometry; colors use DS tokens
// so the indicators respond correctly to theming.

const OUTER =
  'M9 0.577C9.619 0.22 10.381 0.22 11 0.577L17.66 4.423C18.279 4.78 18.66 5.44 18.66 6.155V13.845C18.66 14.56 18.279 15.22 17.66 15.577L11 19.423C10.381 19.78 9.619 19.78 9 19.423L2.34 15.577C1.721 15.22 1.34 14.56 1.34 13.845V6.155C1.34 5.44 1.721 4.78 2.34 4.423L9 0.577Z';
const INNER_HEX =
  'M9.5 5.289C9.809 5.11 10.191 5.11 10.5 5.289L13.83 7.211C14.14 7.39 14.33 7.72 14.33 8.077V11.923C14.33 12.28 14.14 12.61 13.83 12.789L10.5 14.711C10.191 14.89 9.809 14.89 9.5 14.711L6.17 12.789C5.86 12.61 5.67 12.28 5.67 11.923V8.077C5.67 7.72 5.86 7.39 6.17 7.211L9.5 5.289Z';
const CHECKMARK =
  'M12.991 6.429C13.289 6.715 13.299 7.189 13.012 7.487L7.349 13.378C6.816 13.932 5.933 13.941 5.39 13.397L2.992 11C2.7 10.708 2.7 10.234 2.992 9.942C3.285 9.65 3.759 9.65 4.051 9.942L6.358 12.249L11.933 6.45C12.22 6.152 12.693 6.142 12.991 6.429Z';

const variants: Record<StepStatus, React.ReactElement> = {
  inactive: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d={OUTER} fill="var(--p-neutral-200)" />
      <path d={INNER_HEX} fill="var(--p-neutral-400)" />
    </svg>
  ),
  active: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d={OUTER} fill="var(--ds-brand-light)" />
      <path d={INNER_HEX} fill="var(--ds-brand)" />
    </svg>
  ),
  completed: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d={OUTER} fill="var(--ds-positive)" />
      {/* The checkmark path's x-center is ~8 in the 20-unit viewBox; translate 2 units
          right to optically center it at x=10. */}
      <path d={CHECKMARK} fill="var(--p-neutral-white)" transform="translate(2, 0)" />
    </svg>
  ),
};

const StepIndicator = ({ status }: { status: StepStatus }) => variants[status];

export default StepIndicator;
